/* eslint-disable class-methods-use-this */
import { IsServerSideRendering, isObject } from '../utilities';

let environment = 'unknown';

const applicationSettings = {
  development: {
    dotComBaseUrl: 'aHR0cHM6Ly9kZXZhenVyZS5jYXJ2YW5hLmNvbQ==',
    authToken: 'aHR0cHM6Ly9kZXZhenVyZS5jYXJ2YW5hLmNvbS9hY2Nlc3N0b2tlbi9wb3N0cmVxdWVzdGZvcm5ld3Rva2Vu',
    geolocationBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL2dlb2xvY2F0aW9uL2FwaS8=',
    searchBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL21lcmNoLWNvbnRleHQvYXBpLw==',
    contentServiceBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL3N1cHBvcnQtY29udGVudC8=',
    userNotificationsBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL3VzZXItbm90aWZpY2F0aW9ucy9hcGkvdjEv',
    deviceDetectionBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL2RldmljZS1kZXRlY3Rpb24vYXBpLw==',
    cdnUrl: 'aHR0cHM6Ly9jYXJ2YW5hYXNzZXRzZGV2LmJsb2IuY29yZS53aW5kb3dzLm5ldA==',
    cdnFastlyUrl: 'aHR0cHM6Ly9hc3NldHMuZmFzdGx5LnphZ2ZvcndhcmQuY29t',
    publicUrl: '',
    googleAnalyticsTrackingId: 'VUEtMTM2NjU4MzI2LTQ=',
    cdnBlobUrl: 'Ly9jZG5ibG9iLnphZ2ZvcndhcmQuY29t',
    apimUrl: 'YXBpbS56YWdmb3J3YXJkLmNvbQ==',
    discountsBaseApiUrl: 'aHR0cHM6Ly9hcGltLnphZ2ZvcndhcmQuY29tL2Rpc2NvdW50L2FwaQ==',
    chatAiBaseApiUrl: 'aHR0cHM6Ly9hcGlkMS5wcm9wZWwuYWkvdjE=',
    googleTagManagerContainerId: 'R1RNLVdQUEQzSAo=',
    ngcVideos: [
      {
        title: 'V2hhdCBpcyBDYXJ2YW5hPw==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC0xMDYxYjAwYy04YWE1LTQzNWItOTI4OC0yNjBlMWI5ZmIzY2EvV2hhdCUyMGlzJTIwQ2FydmFuYS5tcDQ/c3Y9MjAxNy0wNC0xNyZzcj1jJnNpPTI0ZTRjZDFlLWRhNTQtNGJlOC1iNzc3LTdiNWFiNjYyZGM2OCZzaWc9aE4zSEtneWtVV0ZQWjFMbEIlMkJIN2xISktMVnpXQmRybTV4MWlubFMyMW1FJTNEJnN0PTIwMTktMDYtMTBUMjAlM0E1OCUzQTMwWiZzZT0yMTE5LTA2LTEwVDIwJTNBNTglM0EzMFo=',
        supportContentId: 'MTA1'
      },
      {
        title: 'RmluYW5jaW5nIHdpdGggQ2FydmFuYQ==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC04MTc3YjA2ZS00YWU4LTQ1ZTctOTcyMi00ODkwYWEwNTVkNWIvRmluYW5jaW5nJTIwV2l0aCUyMENhcnZhbmEubXA0P3N2PTIwMTctMDQtMTcmc3I9YyZzaT1lZWU4ZDcwOS1iMzFhLTQ2YmEtODNmNC1iYzg2OGMwMDM2ODcmc2lnPWNKdHVFd0hVQlFSaSUyQnlLam1CY3RCTHE3WHEzTGVpS29LZ0N1VGl3RXphayUzRCZzdD0yMDE5LTA2LTEwVDIwJTNBNTglM0EyM1omc2U9MjExOS0wNi0xMFQyMCUzQTU4JTNBMjNa',
        supportContentId: 'MTA3Cg=='
      },
      {
        title: 'UHVyY2hhc2luZyBmcm9tIENhcnZhbmE=',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC05NGEzMWQ4Ny04YWNlLTRkM2MtODliZC0wODk2NjhlODI2ZTgvUHVyY2hhc2luZyUyMEZyb20lMjBDYXJ2YW5hLm1wND9zdj0yMDE3LTA0LTE3JnNyPWMmc2k9YzUxZmMwNGQtN2FiZS00NDJiLWI4N2UtODExMTkzNjljOTUyJnNpZz1BUDQxeERDUmpjbEszbDdnMzh6NlBVRElTWWVkVDRSZXl2aUpPMzNlVUI0JTNEJnN0PTIwMTktMDYtMTFUMTglM0ExNiUzQTA3WiZzZT0yMTE5LTA2LTExVDE4JTNBMTYlM0EwN1o=',
        supportContentId: 'MTA2'
      }
    ]
  },
  test: {
    dotComBaseUrl: 'aHR0cHM6Ly90ZXN0YXp1cmUuY2FydmFuYS5jb20=',
    authToken: 'aHR0cHM6Ly90ZXN0YXp1cmUuY2FydmFuYS5jb20vYWNjZXNzdG9rZW4vcG9zdHJlcXVlc3Rmb3JuZXd0b2tlbg==',
    geolocationBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS9nZW9sb2NhdGlvbi9hcGkv',
    searchBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS9tZXJjaC1jb250ZXh0L2FwaS8=',
    contentServiceBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS9zdXBwb3J0LWNvbnRlbnQv',
    userNotificationsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS91c2VyLW5vdGlmaWNhdGlvbnMvYXBpL3YxLw==',
    deviceDetectionBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS9kZXZpY2UtZGV0ZWN0aW9uL2FwaS8=',
    cdnUrl: 'aHR0cHM6Ly9jYXJ2YW5hYXNzZXRzdGVzdC5ibG9iLmNvcmUud2luZG93cy5uZXQ=',
    cdnFastlyUrl: 'aHR0cHM6Ly9hc3NldHMuY2FydmFuYXRlY2guY29t',
    publicUrl: 'L2ZpcmVmbHk=',
    googleAnalyticsTrackingId: 'VUEtMTM2NjU4MzI2LTQ=',
    cdnBlobUrl: 'Ly9jZG5ibG9iLmNhcnZhbmF0ZWNoLmNvbQ==',
    apimUrl: 'YXBpbS5jYXJ2YW5hdGVjaC5jb20=',
    discountsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmF0ZWNoLmNvbS9kaXNjb3VudC9hcGk=',
    chatAiBaseApiUrl: 'aHR0cHM6Ly9hcGlkMS5wcm9wZWwuYWkvdjE=',
    googleTagManagerContainerId: 'R1RNLU1NSzlRNQo=',
    ngcVideos: [
      {
        title: 'V2hhdCBpcyBDYXJ2YW5hPw==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC0xMDYxYjAwYy04YWE1LTQzNWItOTI4OC0yNjBlMWI5ZmIzY2EvV2hhdCUyMGlzJTIwQ2FydmFuYS5tcDQ/c3Y9MjAxNy0wNC0xNyZzcj1jJnNpPTI0ZTRjZDFlLWRhNTQtNGJlOC1iNzc3LTdiNWFiNjYyZGM2OCZzaWc9aE4zSEtneWtVV0ZQWjFMbEIlMkJIN2xISktMVnpXQmRybTV4MWlubFMyMW1FJTNEJnN0PTIwMTktMDYtMTBUMjAlM0E1OCUzQTMwWiZzZT0yMTE5LTA2LTEwVDIwJTNBNTglM0EzMFo=',
        supportContentId: 'MTA1'
      },
      {
        title: 'RmluYW5jaW5nIHdpdGggQ2FydmFuYQ==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC04MTc3YjA2ZS00YWU4LTQ1ZTctOTcyMi00ODkwYWEwNTVkNWIvRmluYW5jaW5nJTIwV2l0aCUyMENhcnZhbmEubXA0P3N2PTIwMTctMDQtMTcmc3I9YyZzaT1lZWU4ZDcwOS1iMzFhLTQ2YmEtODNmNC1iYzg2OGMwMDM2ODcmc2lnPWNKdHVFd0hVQlFSaSUyQnlLam1CY3RCTHE3WHEzTGVpS29LZ0N1VGl3RXphayUzRCZzdD0yMDE5LTA2LTEwVDIwJTNBNTglM0EyM1omc2U9MjExOS0wNi0xMFQyMCUzQTU4JTNBMjNa',
        supportContentId: 'MTA3Cg=='
      },
      {
        title: 'UHVyY2hhc2luZyBmcm9tIENhcnZhbmE=',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC05NGEzMWQ4Ny04YWNlLTRkM2MtODliZC0wODk2NjhlODI2ZTgvUHVyY2hhc2luZyUyMEZyb20lMjBDYXJ2YW5hLm1wND9zdj0yMDE3LTA0LTE3JnNyPWMmc2k9YzUxZmMwNGQtN2FiZS00NDJiLWI4N2UtODExMTkzNjljOTUyJnNpZz1BUDQxeERDUmpjbEszbDdnMzh6NlBVRElTWWVkVDRSZXl2aUpPMzNlVUI0JTNEJnN0PTIwMTktMDYtMTFUMTglM0ExNiUzQTA3WiZzZT0yMTE5LTA2LTExVDE4JTNBMTYlM0EwN1o=',
        supportContentId: 'MTA2'
      }
    ]
  },
  uat: {
    dotComBaseUrl: 'aHR0cHM6Ly91YXRhenVyZS5jYXJ2YW5hLmNvbQ==',
    authToken: 'aHR0cHM6Ly91YXRhenVyZS5jYXJ2YW5hLmNvbS9hY2Nlc3N0b2tlbi9wb3N0cmVxdWVzdGZvcm5ld3Rva2Vu',
    geolocationBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS9nZW9sb2NhdGlvbi9hcGkv',
    searchBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS9tZXJjaC1jb250ZXh0L2FwaS8=',
    contentServiceBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS9zdXBwb3J0LWNvbnRlbnQv',
    userNotificationsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS91c2VyLW5vdGlmaWNhdGlvbnMvYXBpL3YxLw==',
    deviceDetectionBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS9kZXZpY2UtZGV0ZWN0aW9uL2FwaS8K',
    cdnUrl: 'aHR0cHM6Ly9jdm5hYXNzZXRzdWF0LmJsb2IuY29yZS53aW5kb3dzLm5ldA==',
    cdnFastlyUrl: 'aHR0cHM6Ly9yZXNvdXJjZXMuZmFzdGx5LmN2dWF0LmNvbQ==',
    publicUrl: 'L2ZpcmVmbHk=',
    googleAnalyticsTrackingId: 'VUEtMTM2NjU4MzI2LTQ=',
    cdnBlobUrl: 'Ly9jZG5ibG9iLmNhcnZhbmEuaW8=',
    apimUrl: 'YXBpbS5jdnVhdC5jb20=',
    discountsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmN2dWF0LmNvbS9kaXNjb3VudC9hcGk=',
    chatAiBaseApiUrl: 'aHR0cHM6Ly9hcGlkMS5wcm9wZWwuYWkvdjE=',
    googleTagManagerContainerId: 'R1RNLU5NMjREUAo=',
    ngcVideos: [
      {
        title: 'V2hhdCBpcyBDYXJ2YW5hPw==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC0xMDYxYjAwYy04YWE1LTQzNWItOTI4OC0yNjBlMWI5ZmIzY2EvV2hhdCUyMGlzJTIwQ2FydmFuYS5tcDQ/c3Y9MjAxNy0wNC0xNyZzcj1jJnNpPTI0ZTRjZDFlLWRhNTQtNGJlOC1iNzc3LTdiNWFiNjYyZGM2OCZzaWc9aE4zSEtneWtVV0ZQWjFMbEIlMkJIN2xISktMVnpXQmRybTV4MWlubFMyMW1FJTNEJnN0PTIwMTktMDYtMTBUMjAlM0E1OCUzQTMwWiZzZT0yMTE5LTA2LTEwVDIwJTNBNTglM0EzMFo=',
        supportContentId: 'MTA1'
      },
      {
        title: 'RmluYW5jaW5nIHdpdGggQ2FydmFuYQ==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC04MTc3YjA2ZS00YWU4LTQ1ZTctOTcyMi00ODkwYWEwNTVkNWIvRmluYW5jaW5nJTIwV2l0aCUyMENhcnZhbmEubXA0P3N2PTIwMTctMDQtMTcmc3I9YyZzaT1lZWU4ZDcwOS1iMzFhLTQ2YmEtODNmNC1iYzg2OGMwMDM2ODcmc2lnPWNKdHVFd0hVQlFSaSUyQnlLam1CY3RCTHE3WHEzTGVpS29LZ0N1VGl3RXphayUzRCZzdD0yMDE5LTA2LTEwVDIwJTNBNTglM0EyM1omc2U9MjExOS0wNi0xMFQyMCUzQTU4JTNBMjNa',
        supportContentId: 'MTA3Cg=='
      },
      {
        title: 'UHVyY2hhc2luZyBmcm9tIENhcnZhbmE=',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC05NGEzMWQ4Ny04YWNlLTRkM2MtODliZC0wODk2NjhlODI2ZTgvUHVyY2hhc2luZyUyMEZyb20lMjBDYXJ2YW5hLm1wND9zdj0yMDE3LTA0LTE3JnNyPWMmc2k9YzUxZmMwNGQtN2FiZS00NDJiLWI4N2UtODExMTkzNjljOTUyJnNpZz1BUDQxeERDUmpjbEszbDdnMzh6NlBVRElTWWVkVDRSZXl2aUpPMzNlVUI0JTNEJnN0PTIwMTktMDYtMTFUMTglM0ExNiUzQTA3WiZzZT0yMTE5LTA2LTExVDE4JTNBMTYlM0EwN1o=',
        supportContentId: 'MTA2'
      }
    ]
  },
  production: {
    dotComBaseUrl: 'aHR0cHM6Ly93d3cuY2FydmFuYS5jb20=',
    authToken: 'aHR0cHM6Ly93d3cuY2FydmFuYS5jb20vYWNjZXNzdG9rZW4vcG9zdHJlcXVlc3Rmb3JuZXd0b2tlbg==',
    geolocationBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vZ2VvbG9jYXRpb24vYXBpLw==',
    searchBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vbWVyY2gtY29udGV4dC9hcGkv',
    contentServiceBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vc3VwcG9ydC1jb250ZW50Lw==',
    userNotificationsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vdXNlci1ub3RpZmljYXRpb25zL2FwaS92MS8=',
    deviceDetectionBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vZGV2aWNlLWRldGVjdGlvbi9hcGkv',
    cdnUrl: 'aHR0cHM6Ly9jYXJ2YW5hYXNzZXRzcHJvZC5ibG9iLmNvcmUud2luZG93cy5uZXQ=',
    cdnFastlyUrl: 'aHR0cHM6Ly9hc3NldHMuZmFzdGx5LmNhcnZhbmEuaW8=',
    publicUrl: 'L2ZpcmVmbHk=',
    googleAnalyticsTrackingId: 'VUEtMTM2NjU4MzI2LTQ=',
    cdnBlobUrl: 'Ly9jZG5ibG9iLmNhcnZhbmEuaW8=',
    apimUrl: 'YXBpbS5jYXJ2YW5hLmlv',
    discountsBaseApiUrl: 'aHR0cHM6Ly9hcGltLmNhcnZhbmEuaW8vZGlzY291bnQvYXBp',
    chatAiBaseApiUrl: 'aHR0cHM6Ly9hcGkucHJvcGVsLmFpL3Yx',
    googleTagManagerContainerId: 'R1RNLVBDQ1AyRwo=',
    ngcVideos: [
      {
        title: 'V2hhdCBpcyBDYXJ2YW5hPw==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC0xMDYxYjAwYy04YWE1LTQzNWItOTI4OC0yNjBlMWI5ZmIzY2EvV2hhdCUyMGlzJTIwQ2FydmFuYS5tcDQ/c3Y9MjAxNy0wNC0xNyZzcj1jJnNpPTI0ZTRjZDFlLWRhNTQtNGJlOC1iNzc3LTdiNWFiNjYyZGM2OCZzaWc9aE4zSEtneWtVV0ZQWjFMbEIlMkJIN2xISktMVnpXQmRybTV4MWlubFMyMW1FJTNEJnN0PTIwMTktMDYtMTBUMjAlM0E1OCUzQTMwWiZzZT0yMTE5LTA2LTEwVDIwJTNBNTglM0EzMFo=',
        supportContentId: 'MTA1'
      },
      {
        title: 'RmluYW5jaW5nIHdpdGggQ2FydmFuYQ==',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC04MTc3YjA2ZS00YWU4LTQ1ZTctOTcyMi00ODkwYWEwNTVkNWIvRmluYW5jaW5nJTIwV2l0aCUyMENhcnZhbmEubXA0P3N2PTIwMTctMDQtMTcmc3I9YyZzaT1lZWU4ZDcwOS1iMzFhLTQ2YmEtODNmNC1iYzg2OGMwMDM2ODcmc2lnPWNKdHVFd0hVQlFSaSUyQnlLam1CY3RCTHE3WHEzTGVpS29LZ0N1VGl3RXphayUzRCZzdD0yMDE5LTA2LTEwVDIwJTNBNTglM0EyM1omc2U9MjExOS0wNi0xMFQyMCUzQTU4JTNBMjNa',
        supportContentId: 'MTA3Cg=='
      },
      {
        title: 'UHVyY2hhc2luZyBmcm9tIENhcnZhbmE=',
        url:
          'aHR0cHM6Ly9jdm5hbWVkaWFzZXJ2aWNlLmJsb2IuY29yZS53aW5kb3dzLm5ldC9hc3NldC05NGEzMWQ4Ny04YWNlLTRkM2MtODliZC0wODk2NjhlODI2ZTgvUHVyY2hhc2luZyUyMEZyb20lMjBDYXJ2YW5hLm1wND9zdj0yMDE3LTA0LTE3JnNyPWMmc2k9YzUxZmMwNGQtN2FiZS00NDJiLWI4N2UtODExMTkzNjljOTUyJnNpZz1BUDQxeERDUmpjbEszbDdnMzh6NlBVRElTWWVkVDRSZXl2aUpPMzNlVUI0JTNEJnN0PTIwMTktMDYtMTFUMTglM0ExNiUzQTA3WiZzZT0yMTE5LTA2LTExVDE4JTNBMTYlM0EwN1o=',
        supportContentId: 'MTA2'
      }
    ]
  },
  unknown: {
    apimUrl: 'YXBpbS56YWdmb3J3YXJkLmNvbQ==',
    authToken: '',
    contentServiceBaseApiUrl: '',
    cdnUrl: '',
    cdnFastlyUrl: '',
    publicUrl: '',
    cdnBlobUrl: '',
    ngcVideos: [
      {
        title: '',
        url: '',
        supportContentId: null
      }
    ]
  }
};

class ApplicationSettings {
  setEnvironment(newEnvironment) {
    environment = newEnvironment;
  }

  getEnvironment() {
    return environment;
  }

  decodeApplicationSetting(applicationSetting) {
    if (IsServerSideRendering) {
      return null;
    }
    return atob(applicationSetting);
  }

  getApplicationSettings() {
    return environment in applicationSettings ? applicationSettings[environment] : applicationSettings.unknown;
  }

  getApplicationSetting(setting) {
    const settings = this.getApplicationSettings();
    if (setting in settings) {
      const requestedSetting = settings[setting];

      if (Array.isArray(requestedSetting)) {
        return this._decodeArray(requestedSetting);
      }
      return this.decodeApplicationSetting(requestedSetting);
    }
    return '';
  }

  _decodeArray(settingsArray) {
    return settingsArray.map(keyVal => {
      if (isObject(keyVal)) {
        const setting = {};
        const props = Object.keys(keyVal);

        props.forEach(prop => {
          if (Array.isArray(setting[prop])) {
            this._decodeArray(setting[prop]);
          }

          setting[prop] = this.decodeApplicationSetting(keyVal[prop]);
        });

        return setting;
      }
      return this.decodeApplicationSetting(keyVal);
    });
  }
}

export default new ApplicationSettings();
